import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'
import './critical/accordion'
import './css/main-uswitch.css'
import './critical/tab'
import './critical/provider-logo'
import './critical/click-tracking'
import 'lite-youtube-embed/src/lite-yt-embed.css'
import 'lite-youtube-embed/src/lite-yt-embed.js'
import './critical/stimulus'

if (typeof window.nerdalytics !== 'undefined') {
  window.nerdalytics.page()
}
